export const generalAnswers = [
  "I'm sorry, but your question is too complicated for me.",
  "I'm sorry, I don't know how to answer your question. Please come back in a few days, maybe I'll be able to give you an answer then.",
  "Unfortunately I do not have an answer to your question. Can you ask it in a different manner?",
  "I am not capable of understanding your question. Could you ask it in a simpler manner?",
  "I'm verry sorry, I don't know how to answer.",
  "Unfortunately I don't know how to answer your question."
];
